import { Injectable } from '@angular/core';
import { EnvironmentType } from '@environment/environment-type';

@Injectable({ providedIn: 'root' })
export class FaviconService {
  /****/
  private static DEFAULT_FAVICON = 'gorilla.svg';

  /****/
  private faviconMap: Map<EnvironmentType, string> = new Map([
    [EnvironmentType.PRODUCTION, 'gorilla-red.svg'],
    [EnvironmentType.TEST, 'gorilla-blue.svg'],
    [EnvironmentType.DEVELOPMENT, FaviconService.DEFAULT_FAVICON],
  ]);
  setFavicon(env: EnvironmentType) {
    const fileName =
      this.faviconMap.get(env) ||
      this.faviconMap.get(EnvironmentType.DEVELOPMENT);
    const link: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") ||
      document.createElement('link');
    link.type = 'image/svg+xml';
    link.rel = 'icon';
    link.href = `assets/images/${fileName}`;
    document.head.appendChild(link);
  }
}
